var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"split-block",class:{ 'is-border': _vm.border }},[_c('span',{staticClass:"prompt-block"}),_c('span',[_vm._v(_vm._s(_vm.split.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }